import { fbt } from 'fbtee'
import { Badge } from './ui/badge'
import { cn } from '../lib/utils'

interface Props {
  className?: string
  /** The source evidence, shown on hover so an admin can sanity-check the flag. */
  reason?: string
}

/**
 * Marks an event whose promoter called it off. Cancelled events stay visible
 * rather than disappearing — people have them in their plans.
 */
export function CancelledBadge({ className, reason }: Props) {
  return (
    <Badge variant="destructive" className={cn('shrink-0', className)} title={reason}>
      {fbt('Cancelled', 'Badge marking an event that the promoter called off')}
    </Badge>
  )
}
